(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('ComplainOnSmsDeleteController',ComplainOnSmsDeleteController);

    ComplainOnSmsDeleteController.$inject = ['$uibModalInstance', 'entity', 'ComplainOnSms'];

    function ComplainOnSmsDeleteController($uibModalInstance, entity, ComplainOnSms) {
        var vm = this;

        vm.complainOnSms = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ComplainOnSms.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
